import { SectionClientsCarousel } from '@sbercloud/uikit-product-site-section';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { getImageParams } from 'src/utils/getImageParams';

import { ClientSlideProps } from '../../types';

type ClientsProps = {
  title: string;
  slides: ClientSlideProps[];
};

export function ClientsCarousel({ title, slides }: ClientsProps) {
  const layoutType = useLayoutType();

  return (
    <SectionClientsCarousel
      layoutType={layoutType}
      data-test-id="clients-carousel"
      title={title}
      items={slides.map((slide) => ({
        img: getImageParams(slide.image).replacedImage ?? slide.image,
        alt: slide.id,
      }))}
    />
  );
}
